import { Component, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { BehaviorSubject } from "rxjs";
import { Global } from "src/app/global";
import { ModalPrevineBrasilHipertensaoComponent } from "src/app/modals/modal-previne-brasil-hipertensao/modal-previne-brasil-hipertensao.component";
import { ApiService } from "src/app/service/apiServices";
import { AuthService } from "src/app/service/auth/auth.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-previne-brasil-aba-mais-acesso",
  templateUrl: "./previne-brasil-aba-mais-acesso.component.html",
  styleUrls: ["./previne-brasil-aba-mais-acesso.component.css"],
})
export class PrevineBrasilAbaMaisAcessoComponent implements OnInit {
  formulario: any = {
    nome_quadrimestre: null,
    cnes: null,
    ine_nome_equipe: null,
    exibir_mudou: false,
    exibir_obito: false,
    cidadao: "",
    micro_area: "",
  };
  configuracaoPrevineBrasilSelecionada: any = null;
  mostrarLista: boolean = false;
  loading: boolean = false;
  listaConfiguracoesPrevineBrasil: any[] = [];
  listaCnes: any[] = [];
  listaIne: any[] = [];
  lstaMicroarea: any[] = [];
  listaRegistros: any[] = [];
  pagina: number = 1;
  private searchText = new BehaviorSubject<string>("");
  itensPorPagina: number = 10;
  totalPagina: number = 1;
  quantidadeTotal: number = 0;
  listaDeRegistrosModal: any[] = [];
  modalRef: BsModalRef;
  mostrarColunas: boolean = true;
  percentage = 0.0;
  corConceito: string = "#ffffff";

  constructor(
    public global: Global,
    public service: ApiService,
    private modalService: BsModalService,
    private authService: AuthService
  ) {
    // this.searchText.pipe(debounceTime(1500)).subscribe((valor) => {
    //   if (valor.length >= 1) {
    //     this.listarRegistrosPrevineBrasil(valor);
    //   }
    // });
  }

  ngOnInit() {
    this.listarRegistrosPrevineBrasil();
    this.listarCnes();
  }

  pesquisar(pagina: number = 1) {
    this.pagina = pagina;
    Swal.fire({
      title: "Favor aguarde",
      allowOutsideClick: false,
      allowEscapeKey: false,
    });

    Swal.showLoading();
    var url = `PrevineMaisAcesso?skip=${this.pagina}&take=${this.itensPorPagina}`;

    url += `&mudou=${this.formulario.exibir_mudou}`;
    url += `&obito=${this.formulario.exibir_obito}`;

    url += `&configuracao_previne_id=${this.configuracaoPrevineBrasilSelecionada}`;
    if (this.formulario.cnes) {
      url += `&cnes=${this.formulario.cnes}`;
    }
    if (this.formulario.ine_equipe) {
      url += `&ine=${this.formulario.ine_equipe}`;
    }
    if (this.formulario.cidadao) {
      url += `&cidadao=${this.formulario.cidadao}`;
    }
    if (this.formulario.micro_area) {
      url += `&micro_area=${this.formulario.micro_area}`;
    }
    this.service
      .Get(url)
      .then((res: any) => {
        this.listaRegistros = res.conteudo;
        this.quantidadeTotal = res.quantidade_total;
        this.totalPagina = Math.ceil(
          res.quantidade_total / this.itensPorPagina
        );
        this.loading = false;
        this.obterNotaConceito();

        Swal.close();
      })
      .catch((err) => {
        Swal.close();
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro na busca.",
          icon: "error",
        });
      });
  }
  obterNotaConceito() {
    this.service
      .Post("PrevineMaisAcesso/calcular-media-conceito", {
        mudou: this.formulario.exibir_mudou,
        obito: this.formulario.exibir_obito,
        configuracao_previne_id: this.configuracaoPrevineBrasilSelecionada,
        cnes: this.formulario.cnes == null ? "" : this.formulario.cnes,
        ine: this.formulario.ine_equipe,
        cidadao: this.formulario.cidadao,
      })
      .then((res: any) => {
        this.percentage = Math.floor(res.media * 100) / 100;
        this.corConceito = this.obterCorPelaNota(res.conceito);
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao obter a nota conceito.",
          icon: "error",
        });
      });
  }

    obterCorPelaNota(nota: string) {
    switch (true) {
      case nota === 'REGULAR':
        return "#e00101ff";
      case nota === 'SUFICIENTE':
        return "#e0dc01ff";
      case nota === 'BOM':
        return "#09af1fff";
      case nota === 'ÓTIMO':
        return "#012ae0ff";
      default:
        return "#ffffff";
    }
  }

  getNotaClass(nota: number): string {
    if (nota < 25) {
      return "text-indicador-vermelho";
    } else if (nota < 50) {
      return "text-indicador-amarelo";
    } else if (nota < 75) {
      return "text-indicador-verde";
    } else {
      return "text-indicador-azul";
    }
  }

  listarIne() {
    this.loading = true;
    var url = "PrevineMaisAcesso/Ine";
    this.service
      .Get(url)
      .then((res: any) => {
        this.listaIne = res;
        this.listarMicroarea();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
      });
  }
  listarMicroarea() {
    this.loading = true;
    var url = "PrevineMaisAcesso/MicroArea";
    this.service
      .Get(url)
      .then((res: any) => {
        this.lstaMicroarea = res;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
      });
  }

  listarCnes() {
    this.loading = true;
    var url = "PrevineMaisAcesso/Cnes";
    this.service
      .Get(url)
      .then((res: any) => {
        this.listaCnes = res;
        this.listarIne();
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
      });
  }

  listarRegistrosPrevineBrasil(busca?: string) {
    this.loading = true;
    var url = "ConfiguracaoPrevineBrasil?Skip=1&Take=50";
    if (busca) {
      url += `&configuracao_previne_id =${busca}`;
    }
    this.service
      .Get(url)
      .then((res: any) => {
        this.listaConfiguracoesPrevineBrasil = res.conteudo;
        this.mostrarLista = true;
        this.pagina = 1;
        this.loading = false;
      })
      .catch((res) => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close();
          this.authService.logoutUser();
        }
        Swal.close();
      });
  }
  onInputChange(valor: string) {
    this.searchText.next(valor.toUpperCase().trim().replace(/\+/g, "%2B"));
  }

  onClickItemIndicador(item: any, tipo: string) {
    var url = `PrevineMaisAcesso/${tipo}?configuracao_previne_id=${item.configuracao_previne_brasil_id}&skip=1&take=50`;
    if (item.cns) {
      url += `&cidadao_cns=${item.cns}`;
    }
    if (item.cpf) {
      url += `&cidadao_cpf=${item.cpf}`;
    }
    this.service
      .Get(url)
      .then((res: any) => {
        this.listaDeRegistrosModal = res.conteudo;
        this.abrirModalIndicador(tipo);
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro ao buscar os atendimentos.",
          icon: "error",
        });
      });
  }
  abrirModalIndicador(tipo: string) {
    this.modalRef = this.modalService.show(
      ModalPrevineBrasilHipertensaoComponent,
      {
        initialState: {
          listaDeRegistros: this.listaDeRegistrosModal,
          tipoIndicador: tipo,
          exibirPaginacao: false,
          rotaApi: `PrevineMaisAcesso/Atendimento?configuracao_previne_id=${this.configuracaoPrevineBrasilSelecionada.id}`,
          quantidadeTotal: this.quantidadeTotal,
        },
        class: "modal-xxl",
      }
    );
  }
  voltarPagina = () => {
    if (this.pagina >= 2) this.pagina = this.pagina - 1;
    this.pesquisar(this.pagina);
  };
  exportarPdf() {
    Swal.fire("Favor aguarde");
    var url = `PrevineMaisAcesso/Pdf`;

    Swal.showLoading();
    this.service
      .PostImpresso(url, {
        mudou: this.formulario.exibir_mudou,
        obito: this.formulario.exibir_obito,
        configuracao_previne_id: this.configuracaoPrevineBrasilSelecionada,
        cnes: this.formulario.cnes == null ? "" : this.formulario.cnes,
        ine: this.formulario.ine_equipe,
        cidadao: this.formulario.cidadao,
        micro_area: this.formulario.micro_area,
      })
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro.",
          icon: "error",
        });
      });
  }
  exportarExcel() {
    Swal.fire("Favor aguarde");
    var url = `PrevineMaisAcesso/csv`;

    Swal.showLoading();
    this.service
      .PostImpresso(url, {
        mudou: this.formulario.exibir_mudou,
        obito: this.formulario.exibir_obito,
        configuracao_previne_id: this.configuracaoPrevineBrasilSelecionada,
        cnes: this.formulario.cnes == null ? "" : this.formulario.cnes,
        ine: this.formulario.ine_equipe,
        cidadao: this.formulario.cidadao,
        micro_area: this.formulario.micro_area,
      })
      .then((res) => {
        if (res) {
          var link: any = res;
          Swal.close();
          window.open(link, "_blank");
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Erro!",
          text: "Ocorreu um erro.",
          icon: "error",
        });
      });
  }
}
